export const DEGREES_IN_RIGHT_ANGLE = 90;
export const DEGREES_IN_HALF_TURN = 180;
